import "./PageHeading.css";

export default function PageHeading({ children, className = "" }) {
  return <h2 className={`desktop-page-heading ${className}`.trim()}>{children}</h2>;
}
